module.exports = __webpack_public_path__ + "img/Close.3d6a2aff.svg";